import { render, staticRenderFns } from "./Studio.vue?vue&type=template&id=50f6d82b&"
import script from "./Studio.vue?vue&type=script&lang=js&"
export * from "./Studio.vue?vue&type=script&lang=js&"
import style0 from "./Studio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Studio.vue"
export default component.exports